import { render, staticRenderFns } from "./verifyPhone.vue?vue&type=template&id=66e68373"
import script from "./verifyPhone.vue?vue&type=script&lang=js"
export * from "./verifyPhone.vue?vue&type=script&lang=js"
import style0 from "./verifyPhone.vue?vue&type=style&index=0&id=66e68373&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports